import Step1 from './Step1-compose';

export default Step1;
